import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-user-roles',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="p-4">
      <h1 class="text-2xl font-bold mb-4">User Roles</h1>
      <p>User roles component coming soon...</p>
    </div>
  `
})
export class UserRolesComponent {} 